import { PromoErrorType } from 'types';

const NOT_EXIST =
  "Oops! That promo code isn't valid. Please double-check the code and try again.";
const NOT_QUALIFY_PRODUCT =
  "This promo code doesn't apply to the items in your cart. Please review the promotion details and try again.";
const NOT_QUALIFY_SERVICE =
  "This promo code doesn't apply to your appointment. Please review the promotion details and try again.";

export const getPromoErrorMessage = (
  type: PromoErrorType,
  isBookingFlow: boolean = false
) => {
  switch (type) {
    case PromoErrorType.NO_ERROR:
      return '';
    case PromoErrorType.DOES_NOT_EXIST:
      return NOT_EXIST;
    case PromoErrorType.DOES_NOT_QUALITY:
      return isBookingFlow ? NOT_QUALIFY_SERVICE : NOT_QUALIFY_PRODUCT;
    default:
      return '';
  }
};
